import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PermissionService } from '@app/core/services/permission/permission.service';
import { ButtonToggleOptionText } from '@components/buttons/button-toggle-group/button-toggle-group.component';

export interface ActionBarItem {
  id: string; // Item id
  label?: string; // Human readable description
  floatLeft?: boolean; // Put the item at the left
  icon?: string; // Icon
  isButton?: boolean; // The item is a button
  styleClass?: string; // Additional class
  tooltip?: string; // Tooltip
  color?: string; // Icon color (e.g. warn)
  isText?: boolean; // The item is a text
  mode?: string; // Button mode (as required by vfs-button component)
  secondary?: boolean; // Button secondary color (as optional by vfs-button component)
  disabled?: boolean; // Disabled for whatever reason
  toggleOptions?: ButtonToggleOptionText[]; // By setting this property a button group is created
  permissions?: Array<string> | string; //Permissions... if not allowed just disable the button
}

export interface ActionBarClick {
  item: ActionBarItem;
}

@Component({
  selector: 'vfs-action-bar',
  templateUrl: './action-bar.component.html',
  styleUrls: ['./action-bar.component.scss']
})
export class ActionBarComponent implements OnInit {
  @Output() actionBarClicked = new EventEmitter<ActionBarClick>();
  @Input() actionBarItems: ActionBarItem[] = null;
  @Input() useTemplate = false;

  constructor(private permissionService: PermissionService) {}

  /**
   * Initialize component
   */
  ngOnInit() {}

  /**
   * User clicks in a toolbar button
   *
   * @param item the item
   */
  clickOnTab(item: ActionBarItem) {
    if (!item.isText && !item.disabled && !item.toggleOptions) {
      this.actionBarClicked.emit({ item });
    }
  }

  /**
   * Click on a toggle option
   *
   * @param evt the event
   */
  clickOnToggle(item: ActionBarItem, evt: any) {
    // Create a dummy item with the id as expected by the consumer of this component
    const newItem: ActionBarItem = { id: item.label, label: evt };
    this.actionBarClicked.emit({ item: newItem });
  }

  /**
   * Check if the option has the rights enabled
   *
   * @param permissions array of permissions or a single permission
   * @return true if the user can use this option
   */
  hasPermission(permissions: Array<string> | string): boolean {
    return this.permissionService.hasPermission(permissions);
  }
}
